//import firebaseConfig from '../../config/firebaseConfig';
import firebase from "firebase";
// Initialize Firebase
//firebase.initializeApp(firebaseConfig);

class HashedDataService {

  constructor(collectionName) {
    this.collectionName = collectionName;
    this.hashedUserRef = firebase.firestore().collection(this.collectionName);
  }


// getter for retriving hashed user data from firestore
  getHashedUserData = async () => {
    try {
        const result = await this.hashedUserRef.get();
        return result.docs.map(doc => doc.data());
      }
    catch(error) {
        window.alert('404 error');
      }
    }
}


export {
  HashedDataService
};
